/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useRef, useEffect, useContext, useCallback } from 'react';
import { debounce } from "lodash";
import { Formik } from "formik";
import { Icon } from 'components';
import { GlobalAuthContext } from 'store/context';
import { GlobalLoaderContext } from 'store/context';
import { useHistory } from 'react-router-dom';
import SearchField from 'components/Form/SearchField';
import InputField from 'components/Form/InputField';
import Label from 'components/Form/Label';
import Row from 'components/Grid/Row';
import { TextEditorBox } from 'components/index';
import { Col } from 'components/Grid';
import {
  Dialog,
  DialogBody,
  SearchContent,
  Scrollbox,
  MessageContainer,
  ContentIcons,
  ContentIcons2,
  ContentTextArea,
  RowMessage,
  Comp,
  BallonMessageArrowLeft,
  BallonMessageArrowRight,
  RowAttchments,
  NewRowAttchments,
  AttachmentFiles,
  BoxAttachment,
  DateTimeText, Container, Button
} from './styles';
import { Field } from 'formik';
import RecipientSelection from './RecipientSelection';
import { FitinsurAPI, MessageCenter } from 'utils';
import DragZoneUpload from 'components/DragZoneUpload';
import TagsList3 from "components/TagList3";
import { FileIcon, defaultStyles } from 'react-file-icon';
import ModalConfirmation from 'components/ModalConfirmation/index';
import ShareDocuments from './ShareDocuments';

export default function MessageExchangeEmail({ children, show, idOperation, idPersonInsurer, insurersResponseList, isDocumentFolder }) {
  const [visible, setVisible] = useState(show);
  const authContext = useContext(GlobalAuthContext);
  const [showRecipientList, setShowRecipientList] = useState(false);
  const [attachmentFile, setAttachmentFile] = useState(false);
  const [defaultScreen, setDefaultScreen] = useState(true);
  const [attachmentsMessage, setAttachmentsMessage] = useState([])
  const [modalResendNbi, setModalResendNbi] = useState(false);
  const [showShareDocuments, setShowShareDocuments] = useState(false);
  const [infosHash, setInfosHash] = useState([]);

  const [initialMessage, setInitialMessage] = useState("");
  const loading = useContext(GlobalLoaderContext);
  const [messages, setMessages] = useState([])
  const [emailTracking, setEmailTracking] = useState("")
  const [editUrl, setEditUrl] = useState("");
  const [clickShare, setClickShare] = useState(false);

  const [searchListMessages, setSearchListMessages] = useState([]);
  const [uploading, setUploading] = useState(false);

  const myRef = useRef();
  const formik = useRef();
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const refs = useRef({});
  const scrollRef = useRef();

  function handleGetMessages() {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestGetNbiChat(idOperation, idPersonInsurer, '')
      .then(response => response.json())
      .then(data => {
        loading.stop();
        if (data.ret_value.length) {
          setMessages(data.ret_value);
        }
        setEmailTracking(data?.replyTo || '')
      }).catch((error) => {
        loading.stop();
        mc.error(`There was an error while fetching your data: ${handleGetMessages.name} \n` + error);
        console.error('fitPostDocument - Error:', error);
      });
  };


  function getHash() {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestGetHash(idOperation)
      .then(response => response.json())
      .then(data => {
        loading.stop();
        if (data.ret_code != 200) {
          mc.error(data.ret_msg_details);
          return;
        }

        if (data.ret_value.metadataReport) {
          setInfosHash(data.ret_value);
          setClickShare(true);
        } else {
          setShowShareDocuments(!showShareDocuments);
          setDefaultScreen(!defaultScreen);
        }

      }).catch((error) => {
        loading.stop();
        mc.error(`There was an error while fetching your data: ${getHash.name}\n` + error);
        console.error('fitPostDocument - Error:', error);
      });
  };

  useEffect(() => {
    if (authContext.status !== true) {
      mc.error("User is not authenticated, please Login");
      history.push('/login')
      return;
    }
    handleGetMessages();
    handleGetLinkUpdateManually();
  }, []);


  function handleGetLinkUpdateManually() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.marketSelectionUpdateManually(idOperation, idPersonInsurer)
      .then(a => {
        if (a.status !== 200) {
          a.json().then(res => {
            mc.error(res.ret_msg_details);
            return;
          })

        } else {
          a.text().then((response) => {
            response = JSON.parse(response);
            setEditUrl(response.ret_value[0].lnkAccess);
          })
        }
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleGetLinkUpdateManually.name}\n` + error);
        console.error('fitPostDocument - Error:', error);
      });
  };

  function handleUpdateManually() {
    window.open(editUrl + "?authContextToken=" + authContext.token + '&renderComponents=true', '_blank');
  };


  const handleCreateNbiChatMessage = (message) => {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestCreateNbiChatMessage(idOperation, message, idPersonInsurer, attachmentsMessage)
      .then(response => response.json())
      .then(data => {
        if (data.ret_code != 200) {
          loading.stop();
          mc.error(data.ret_msg_details);
          return;
        }
        loading.stop();
        setInitialMessage("<p></p>");
        handleGetMessages();
        setAttachmentsMessage([]);
        setUploading(false);
      }).catch((error) => {
        loading.stop();
        mc.error(`There was an error while fetching your data: ${handleCreateNbiChatMessage.name}\n` + error);
        console.error('fitPostDocument - Error:', error);
      });
  }

  const handleResend = async () => {
    fitinsur.setAuthToken(authContext.token);
    loading.start();
    fitinsur.reSendNbiForm(idOperation, idPersonInsurer)
      .then(x => x.json())
      .then(res => {
        loading.stop();
        if (res.ret_code != 200) {
          mc.error(res.ret_msg_details);
          return;
        }
      })

  }

  useEffect(() => {
    setVisible(show);
  }, [show]);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => document.body.style.overflow = 'unset';
  }, []);

  const scrollToLastContent = () => {
    if (messages.length) {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
    }
  };

  useEffect(() => {
    scrollToLastContent();
  }, [messages]);

  const changeDefaultState = state => setDefaultScreen(state);
  const changeRicipientState = state => setShowRecipientList(state);
  const changeShareDocumentsState = state => setShowShareDocuments(state);
  const changeInitialMessage = state => concatMessageToLink(state);
  const concatMessageToLink = link => {
    const linkString = `<a  href="${link}" target="_blank">Click here to access SUPPORT files</a>`;
    const message = formik.current.values.internalMessage + linkString
    setInitialMessage(message);
  }

  const renderAttachments = (attachments) => {
    if (!attachments.length) return <></>;
    return <RowAttchments>
      {attachments.map(file => {
        if (!file.nameFile) return <></>;

        const fileExtension = file.nameFile.split('.').pop();
        return (
          <BoxAttachment href={file.urlLink} rel="noopener noreferrer" target="_blank">
            <div style={{ width: '25px', minWidth: '25px', maxWidth: '25px' }}>
              <FileIcon extension={fileExtension} {...defaultStyles[fileExtension]} />
            </div>
            <AttachmentFiles href={file.urlLink} rel="noopener noreferrer" target="_blank" style={{ marginLeft: '10px' }}>{file.nameFile}</AttachmentFiles>
          </BoxAttachment>
        )
      })}
    </RowAttchments>
  }

  const renderSelectedScreen = () => {
    if (defaultScreen) {
      return messages && messages.map((message, index) => {
        const { fromName, fromEmail, toRecipients, subject } = message.documentMetadata;
        return (
          <Container style={{ marginBottom: 40 }} key={index}>
            <RowMessage>
              {message.documentMetadata.idPersonInternalUser ? (
                <BallonMessageArrowRight ref={ref => refs.current[message.idDocument] = ref} id={message.idDocument}>
                  <span>
                    <strong style={{ fontSize: '14px' }}>{fromName || ''}</strong>&nbsp;
                  </span><br />
                  <span style={{ fontSize: '14px' }}><strong>To:</strong> {toRecipients || ''}</span><br />
                  <span style={{ fontSize: '14px' }}><strong>Subject:</strong> {subject || ''}</span><br />

                  <div dangerouslySetInnerHTML={{ __html: message.documentContent }} />
                  {renderAttachments(message.attachments)}
                </BallonMessageArrowRight>
              ) : (
                <BallonMessageArrowLeft ref={ref => refs.current[message.idDocument] = ref} id={message.idDocument}>
                  <span>
                    <strong style={{ fontSize: '14px' }}>{fromName || ''}</strong>&nbsp;
                    <span style={{ fontSize: '12px' }}>&lt;{fromEmail || ''}&gt;</span>
                  </span><br />
                  <span style={{ fontSize: '14px' }}><strong>To:</strong> {toRecipients || ''}</span><br />
                  <span style={{ fontSize: '14px' }}><strong>Subject:</strong> {subject || ''}</span><br /><br />

                  <div dangerouslySetInnerHTML={{ __html: message.documentContent }} />
                  {renderAttachments(message.attachments)}
                </BallonMessageArrowLeft>
              )}
            </RowMessage>
            <DateTimeText isInternal={message.documentMetadata.idPersonInternalUser}>
              {new Date(message.effectiveDate).toLocaleString()}
            </DateTimeText>
          </Container>
        )
      })
    } else if (showRecipientList) {
      return <RecipientSelection
        insurersListResponse={insurersResponseList}
        idPersonInsurer={idPersonInsurer}
        idOperation={idOperation}
        show={showRecipientList}
        changeState={changeDefaultState}
        screenState={defaultScreen}
        changeRicipientState={changeRicipientState}
      />
    } else if (attachmentFile) {
      return (
        <>
          <DragZoneUpload
            s3upload={true}
            idPersonInsurer={idPersonInsurer}
            idOperation={idOperation}
            autoUpload={true}
            isInternalDocument={true}
            documentType={{
              idAnswerOption: 682,
              dsAnswerOption: "Communications / e-mails"
            }}
            fullHeight
            multiple
            documentTypeRequired={false}
            onSuccess={(uploadedFiles) => {
              setAttachmentsMessage([...attachmentsMessage, ...uploadedFiles]);
              setUploading(true);
            }}
          />
          <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "flex-end" }}>
            <Button
              primary
              onClick={() => {
                setAttachmentFile(false)
                setDefaultScreen(!defaultScreen)
              }}>
              DONE
            </Button>
          </div>
        </>
      )
    } else if (showShareDocuments) {
      return (
        <ShareDocuments
          idOperation={idOperation}
          show={showShareDocuments}
          changeState={changeDefaultState}
          screenState={defaultScreen}
          changeShareDocumentsState={changeShareDocumentsState}
          changeInitialMessage={changeInitialMessage}
        />
      )
    }
  }

  const handleClick = id => {
    window.location.href = `#${id}`;
  }


  const searchMessages = async searchValue => {
    if (searchValue.length >= 3) {
      try {
        fitinsur.setAuthToken(authContext.token);
        fitinsur.requestGetNbiChat(idOperation, idPersonInsurer, searchValue || '').then((response) => response.json()).then((data) => {
          if (data.ret_code != 200) {
            return;
          }

          data.ret_value = data.ret_value?.map(v => ({ ...v, id: v.idDocument, personName: `${v.documentContent}` }))
          setSearchListMessages(data.ret_value);
        });
      } catch (err) {
        console.log("FETCH_FAILURE: ", err);
      }
    }
  }

  const debouncedChangeHandler = useCallback(debounce(searchMessages, 300), []);

  const removeAttachment = item => {
    let elementToRemove, newAttachments;

    elementToRemove = attachmentsMessage.find((att, index) => index === item);
    newAttachments = attachmentsMessage.filter(attachment => attachment.documentId !== elementToRemove.documentId);
    setAttachmentsMessage(newAttachments);
  }

  return (
    <Formik
      innerRef={formik}
      initialValues={{ internalMessage: "", searchInternalMessage: "" }}
      onSubmit={handleCreateNbiChatMessage}
    >
      {formikProps => {
        return (
          <Dialog canShow={visible} >
            <DialogBody ref={myRef}>
              <SearchContent>
                {children}
                <Comp>
                  <Field
                    style={{ width: '100%' }}
                    smallInput={false}
                    placeholder="Search"
                    formatTextHtml
                    name="searchInternalMessage"
                    component={SearchField}
                    onShowChatInsurer
                    value={formikProps.values.searchInternalMessage}
                    searchList={searchListMessages}
                    onChange={debouncedChangeHandler}
                    filterModal
                    onFocus={() => {
                      setSearchListMessages([]);
                      if (formikProps?.values?.searchInternalMessage?.length >= 3) searchMessages(formikProps.values.searchInternalMessage);
                    }}
                    onSearchSelect={(selectedValue) => {
                      handleClick(selectedValue.idDocument);
                      setSearchListMessages([]);
                    }}
                  />
                </Comp>
              </SearchContent>

              <Scrollbox
                ref={scrollRef}
                onScroll={e => e.stopPropagation()}
              >
                {renderSelectedScreen()}
                <ModalConfirmation
                  text="Are you sure you want to re-send the NBI Request ?"
                  show={modalResendNbi}
                  onConfirm={() => {
                    handleResend()
                    setModalResendNbi(false)
                    setDefaultScreen(true)
                  }}
                  onCancel={() => {
                    setModalResendNbi(false)
                    setDefaultScreen(true)
                  }}
                />

                {clickShare &&
                  <ModalConfirmation
                    text="Do you want to change the sharing settings?"
                    show={clickShare}
                    onConfirm={() => {
                      setShowShareDocuments(!showShareDocuments);
                      setDefaultScreen(!defaultScreen);
                      setClickShare(false);
                      setShowRecipientList(false);
                    }}
                    onCancel={() => {
                      concatMessageToLink(infosHash.lnkAccessShared);
                      setClickShare(false);
                    }}
                  />
                }
              </Scrollbox>

              <MessageContainer isUploading={uploading}>
                <ContentTextArea>
                  <TextEditorBox
                    disableFullScreen
                    name="internalMessage"
                    value={formikProps.values.internalMessage}
                    initialValue={initialMessage}
                    onChange={e => formikProps?.setFieldValue('internalMessage', e)}
                  />
                  {(uploading && attachmentsMessage) && (
                    <NewRowAttchments>
                      <Col md={12} sm={12}>
                        <TagsList3
                          small
                          tags={attachmentsMessage.filter(file => file.fileName).map(file => ({ ...file, dsTypeDocument: file?.documentType?.dsAnswerOption, urlLink: file.fileUrl }))}
                          disableType
                          hideTrash={false}
                          removeTag={(index) => removeAttachment(index)}
                        />
                      </Col>
                    </NewRowAttchments>
                  )}
                </ContentTextArea>
                <Row>
                  <Col xs={12} sm={2} md={2} lg={2} xl={2} style={{ padding: 0, alignItems: 'center', display: 'flex' }}>
                    <Row style={{ justifyContent: 'flex-start' }}>
                      {!isDocumentFolder &&
                        <>
                          <Col sm={2} xs={6}>
                            <Icon
                              name="edit-grey"
                              title="Update NBI Request manually"
                              style={{ margin: 0, cursor: 'pointer' }}
                              onClick={() => handleUpdateManually()}
                            />
                          </Col>
                          <Col sm={2} xs={6}>
                            <Icon
                              title="Re-send the NBI Request"
                              name="resend-nbi-grey"
                              style={{ cursor: 'pointer', margin: 0 }}
                              onClick={() => {
                                setModalResendNbi(!modalResendNbi)
                                setDefaultScreen(defaultScreen)
                                setAttachmentFile(false);
                                setShowRecipientList(false);
                              }} />
                          </Col>
                        </>}
                    </Row>
                  </Col>
                  <Col xs={12} sm={6} md={6} lg={6} xl={6} style={{ padding: 0, alignItems: 'center', display: 'flex' }}>
                    <Row style={{ width: '100%' }}>
                      <Col xs={12} sm={3} md={3} lg={3} xl={3}>
                        <Label>E-mail tracking</Label>
                      </Col>
                      <Col xs={12} sm={9} md={9} lg={9} xl={9}>
                        <Field
                          name="emailTracking"
                          component={InputField}
                          customValue={emailTracking}
                          readOnly
                          validation={false}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={12} sm={4} md={4} lg={4} xl={4} style={{ padding: 0, alignItems: 'center', display: 'flex', justifyContent: 'flex-end' }}>
                    <Row style={{ justifyContent: 'flex-end', marginRight: 20 }}>
                      {!isDocumentFolder &&
                        <>
                          <Col sm={2} xs={2}>
                            <Icon
                              title="Recipient(s) selection"
                              name="add-person-grey"
                              style={{ cursor: 'pointer', margin: 0 }}
                              onClick={() => {
                                setShowRecipientList(!showRecipientList);
                                setAttachmentFile(false);
                                setDefaultScreen(!defaultScreen)
                              }
                              } />
                          </Col>
                          <Col sm={2} xs={2}>
                            <Icon
                              title="Copy/Re-send the access hash"
                              name="hash-access-grey"
                              style={{ cursor: 'pointer', margin: 0 }}
                              onClick={() => {
                                const url = editUrl + "?authContextToken=" + authContext.token + '&renderComponents=true'
                                const message = formikProps.values.internalMessage + `<a  href="${url}" target="_blank">Click here to decline/indicate NBI Request</a>`
                                setInitialMessage(message)
                              }} />
                          </Col>
                        </>
                      }
                      <Col sm={2} xs={2}>
                        <Icon
                          title="Share Files"
                          name="share-grey"
                          style={{ cursor: 'pointer', margin: 0 }}
                          onClick={() => {
                            setShowRecipientList(false);
                            getHash();
                          }} />
                      </Col>
                      <Col sm={2} xs={2}>
                        <Icon
                          title="Attachment(s)"
                          name="attachment-grey"
                          style={{ cursor: 'pointer', margin: 0 }}
                          onClick={() => {
                            setAttachmentFile(!attachmentFile);
                            setDefaultScreen(!defaultScreen);
                            setShowRecipientList(false);
                          }} />
                      </Col>
                      <Col sm={2} xs={2}>
                        <Icon
                          title="Send message(s)"
                          name="send-grey"
                          style={{ cursor: 'pointer', margin: 0 }}
                          onClick={() => {
                            handleCreateNbiChatMessage(formikProps.values)
                          }} />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </MessageContainer>
            </DialogBody>
          </Dialog>
        )
      }}
    </Formik>
  )
}
